import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  damagedFromModel,
  validateDamagedCondition,
  type DamagedState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const DAMAGED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DamagedState>>,
): ConditionType<DamagedState, Condition.Damaged> => ({
  name: "Damaged",
  description(state) {
    return "Return is for damaged product";
  },
  Details(props: ConditionTypeDetailsProps<DamagedState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return damagedFromModel(model);
  },
  toModel(state) {
    return { type: Condition.DAMAGED };
  },
  valid(state) {
    return validateDamagedCondition(state).valid;
  },
});

export { type DamagedState } from "@redotech/redo-model/return-flow/condition-validate";
